import styled from 'styled-components';
import Skeleton from '../../../components/Skeleton';
import { tokens, media } from '../../../design/tokens';

export const Container = styled.section`
  display: flex;
  padding: ${tokens.space.lg} ${tokens.space.gutter};
  width: 100%;
  justify-content: center;
  gap: ${tokens.space.xl};
  flex-direction: column;
`;

export const ShimmerBackPage = styled(Skeleton)`
  width: 200px;
  height: 40px;
  margin-top: ${tokens.space.md};
  border-radius: ${tokens.radius.sm};
`;

export const ShimmerPurchase = styled(Skeleton)`
  width: 100%;
  max-width: 1280px;
  margin-top: ${tokens.space.md};
  border-radius: ${tokens.radius.sm};
`;

export const ShimmerCardHeader = styled(Skeleton)`
  width: 100%;
  height: 80px;
  margin-bottom: ${tokens.space.md};
  border-radius: ${tokens.radius.sm};
`;

export const ShimmerCardDivider = styled(Skeleton)`
  width: 100%;
  height: 2px;
  margin-bottom: ${tokens.space.md};
  border-radius: 1px;
`;

export const ShimmerCardTable = styled(Skeleton)`
  width: 100%;
  height: 120px;
  border-radius: ${tokens.radius.sm};
`;

export const SkeletonCard = styled.div`
  width: 100%;
  max-width: 1280px;
  display: flex;
  padding: ${tokens.space.lg};
  flex-direction: column;
  gap: ${tokens.space.md};
  border-radius: ${tokens.radius.sm};
  background: ${tokens.color.cardCharcoal};
`;

export const EmptyPurchase = styled.p`
  color: ${tokens.color.textWhite};
  width: fit-content;
  margin: 0 auto;
  font-family: ${tokens.font.body.family};
  font-size: ${tokens.font.body.size};
`;
